import {
  fetchTrustedSuppliers,
  fetchSupplierTypes,
  fetchGeographicalCoverage,
  fetchFaqs,
  fetchBlogs,
  fetchBlog,
} from '../util/api';

export const SEARCH_TRUSTED_SUPPLIERS_REQUEST = 'app/strapi/SEARCH_TRUSTED_SUPPLIERS_REQUEST';
export const SEARCH_TRUSTED_SUPPLIERS_SUCCESS = 'app/strapi/SEARCH_TRUSTED_SUPPLIERS_SUCCESS';
export const SEARCH_TRUSTED_SUPPLIERS_ERROR = 'app/strapi/SEARCH_TRUSTED_SUPPLIERS_ERROR';

export const SEARCH_SUPPLIER_TYPES_REQUEST = 'app/strapi/SEARCH_SUPPLIER_TYPES_REQUEST';
export const SEARCH_SUPPLIER_TYPES_SUCCESS = 'app/strapi/SEARCH_SUPPLIER_TYPES_SUCCESS';
export const SEARCH_SUPPLIER_TYPES_ERROR = 'app/strapi/SEARCH_SUPPLIER_TYPES_ERROR';

export const SEARCH_GEOGRAPHICAL_COVERAGE_REQUEST =
  'app/strapi/SEARCH_GEOGRAPHICAL_COVERAGE_REQUEST';
export const SEARCH_GEOGRAPHICAL_COVERAGE_SUCCESS =
  'app/strapi/SEARCH_GEOGRAPHICAL_COVERAGE_SUCCESS';
export const SEARCH_GEOGRAPHICAL_COVERAGE_ERROR = 'app/strapi/SEARCH_GEOGRAPHICAL_COVERAGE_ERROR';

export const SEARCH_FAQS_REQUEST = 'app/strapi/SEARCH_FAQS_REQUEST';
export const SEARCH_FAQS_SUCCESS = 'app/strapi/SEARCH_FAQS_SUCCESS';
export const SEARCH_FAQS_ERROR = 'app/strapi/SEARCH_FAQS_ERROR';

export const SEARCH_BLOGS_REQUEST = 'app/strapi/SEARCH_BLOGS_REQUEST';
export const SEARCH_BLOGS_SUCCESS = 'app/strapi/SEARCH_BLOGS_SUCCESS';
export const SEARCH_BLOGS_ERROR = 'app/strapi/SEARCH_BLOGS_ERROR';
export const SEARCH_SINGLE_BLOGS_SUCCESS = 'app/strapi/SEARCH_SINGLE_BLOGS_SUCCESS';

// Initial State
const initialState = {
  trustedSuppliers: [],
  supplierTypes: [],
  geographicalCoverage: [],
  faqsData: [],
  searchInProgress: false,
  error: null,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_TRUSTED_SUPPLIERS_REQUEST:
    case SEARCH_SUPPLIER_TYPES_REQUEST:
    case SEARCH_GEOGRAPHICAL_COVERAGE_REQUEST:
    case SEARCH_FAQS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
      };
    case SEARCH_BLOGS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
      };
    case SEARCH_BLOGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        blogsData: payload?.data?.blogs || [],
        blogTags: payload?.data?.filters || [],
      };
    case SEARCH_SINGLE_BLOGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        singleBlogData: payload?.data || [],
      };
    case SEARCH_BLOGS_ERROR:
      return { ...state, searchInProgress: false, searchBlogsError: true };
    case SEARCH_TRUSTED_SUPPLIERS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        trustedSuppliers: payload,
      };
    case SEARCH_SUPPLIER_TYPES_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        supplierTypes: payload,
      };
    case SEARCH_GEOGRAPHICAL_COVERAGE_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        geographicalCoverage: payload,
      };
    case SEARCH_FAQS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        faqsData: payload,
      };

    case SEARCH_TRUSTED_SUPPLIERS_ERROR:
    case SEARCH_SUPPLIER_TYPES_ERROR:
    case SEARCH_GEOGRAPHICAL_COVERAGE_ERROR:
    case SEARCH_FAQS_ERROR:
      return {
        ...state,
        searchInProgress: false,
        error: payload,
      };

    default:
      return state;
  }
}

// Selectors
export const getTrustedSuppliers = state => state.strapi.trustedSuppliers;
export const getSupplierTypes = state => state.strapi.supplierTypes;
export const getGeographicalCoverage = state => state.strapi.geographicalCoverage;
export const getFaqs = state => state.strapi.faqsData;
export const getSearchInProgress = state => state.strapi.searchInProgress;
export const getSearchError = state => state.strapi.error;

export const getBlogsTagsSelector = state => state.strapi?.blogTags;
export const getBlogsInProgress = state => state.strapi?.searchInProgress;
export const getBlogsSelector = state => state.strapi?.blogsData;
export const getBlogSelector = state => state.strapi.singleBlogData;

// Action Creators
export const searchTrustedSuppliersRequest = () => ({ type: SEARCH_TRUSTED_SUPPLIERS_REQUEST });
export const searchTrustedSuppliersSuccess = data => ({
  type: SEARCH_TRUSTED_SUPPLIERS_SUCCESS,
  payload: data,
});
export const searchTrustedSuppliersError = error => ({
  type: SEARCH_TRUSTED_SUPPLIERS_ERROR,
  payload: error,
});

export const searchBlogsRequest = () => ({
  type: SEARCH_BLOGS_REQUEST,
});

export const searchBlogsSuccess = response => ({
  type: SEARCH_BLOGS_SUCCESS,
  payload: { data: response },
});

export const searchSingleBlogsSuccess = response => ({
  type: SEARCH_SINGLE_BLOGS_SUCCESS,
  payload: { data: response },
});

export const searchBlogsError = () => ({
  type: SEARCH_BLOGS_ERROR,
});

export const searchSupplierTypesRequest = () => ({ type: SEARCH_SUPPLIER_TYPES_REQUEST });
export const searchSupplierTypesSuccess = data => ({
  type: SEARCH_SUPPLIER_TYPES_SUCCESS,
  payload: data,
});
export const searchSupplierTypesError = error => ({
  type: SEARCH_SUPPLIER_TYPES_ERROR,
  payload: error,
});

export const searchGeographicalCoverageRequest = () => ({
  type: SEARCH_GEOGRAPHICAL_COVERAGE_REQUEST,
});
export const searchGeographicalCoverageSuccess = data => ({
  type: SEARCH_GEOGRAPHICAL_COVERAGE_SUCCESS,
  payload: data,
});
export const searchGeographicalCoverageError = error => ({
  type: SEARCH_GEOGRAPHICAL_COVERAGE_ERROR,
  payload: error,
});

export const searchFaqsRequest = () => ({ type: SEARCH_FAQS_REQUEST });
export const searchFaqsSuccess = data => ({ type: SEARCH_FAQS_SUCCESS, payload: data });
export const searchFaqsError = error => ({ type: SEARCH_FAQS_ERROR, payload: error });

// Thunks
export const fetchAllTrustedSuppliers = filters => async dispatch => {
  dispatch(searchTrustedSuppliersRequest());
  try {
    const response = await fetchTrustedSuppliers({ ...filters });
    dispatch(searchTrustedSuppliersSuccess(response.trustedSuppliers));
  } catch (error) {
    dispatch(searchTrustedSuppliersError(error));
  }
};

export const fetchAllSupplierTypes = () => async dispatch => {
  dispatch(searchSupplierTypesRequest());
  try {
    const response = await fetchSupplierTypes({});
    dispatch(searchSupplierTypesSuccess(response.supplierTypes));
  } catch (error) {
    dispatch(searchSupplierTypesError(error));
  }
};

export const fetchAllGeographicalCoverage = () => async dispatch => {
  dispatch(searchGeographicalCoverageRequest());
  try {
    const response = await fetchGeographicalCoverage({});
    dispatch(searchGeographicalCoverageSuccess(response.geographicalCoverage));
  } catch (error) {
    dispatch(searchGeographicalCoverageError(error));
  }
};

export const fetchAllFaqs = (params) => async dispatch => {
  dispatch(searchFaqsRequest());
  try {
    const response = await fetchFaqs({ ...params });
    dispatch(searchFaqsSuccess(response.faqs));
  } catch (error) {
    dispatch(searchFaqsError(error));
  }
};

export const fetchSingleBlog = params => async (dispatch, getState, sdk) => {
  dispatch(searchBlogsRequest());
  try {
    const response = await fetchBlog({ ...params });
    dispatch(searchSingleBlogsSuccess(response?.blog));
    return response;
  } catch (error) {
    dispatch(searchBlogsError());
    console.log(error, 'Error while fetching single blog');
  }
};

export const fetchAllBlogs = params => async (dispatch, getState, sdk) => {
  dispatch(searchBlogsRequest());

  try {
    let blogsResponse;

    // Fetch blogs
    blogsResponse = await fetchBlogs({ ...params });

    dispatch(
      searchBlogsSuccess({
        blogs: blogsResponse?.blogs,
      })
    );
    return blogsResponse?.blogs;
  } catch (error) {
    dispatch(searchBlogsError());
  }
};